// Botón «Configurar cookies» del pie (§8.2): reabre las preferencias del banner de cookies de Shopify
// (window.privacyBanner.showPreferences). El banner lo inyecta Shopify y puede cargar después que la página:
// si aún no está, se pide la Customer Privacy API (Shopify.loadFeatures) y se espera hasta 2 s a que aparezca.
// Si no llega (sin Shopify o con el banner desactivado), lo dice con texto en una región de estado.
const WAIT_MS = 2000;

function showPreferences() {
  if (window.privacyBanner?.showPreferences) {
    window.privacyBanner.showPreferences();
    return true;
  }
  return false;
}

function waitForBanner() {
  return new Promise((resolve) => {
    const start = performance.now();
    (function check() {
      if (window.privacyBanner?.showPreferences) resolve(true);
      else if (performance.now() - start > WAIT_MS) resolve(false);
      else setTimeout(check, 100);
    })();
  });
}

function announceUnavailable(button) {
  let status = button.parentElement.querySelector('.site-footer__cookie-status');
  if (!status) {
    status = document.createElement('p');
    status.className = 'site-footer__cookie-status';
    status.setAttribute('role', 'status');
    button.after(status);
  }
  requestAnimationFrame(() => {
    status.textContent = button.dataset.unavailable;
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cookie-preferences]');
  if (!button || showPreferences()) return;
  button.setAttribute('aria-busy', 'true');
  try {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  } catch {
    // Sin la API de Shopify (vista previa local): solo queda esperar al banner.
  }
  const ready = await waitForBanner();
  button.removeAttribute('aria-busy');
  if (!(ready && showPreferences())) announceUnavailable(button);
});
